export const GifDescriptions: Record<string, string> = {
  "Header": "GIF Header. Signature (GIF) and Version (87a or 89a).",
  "Logical Screen Descriptor": "Defines the width, height, and color resolution of the image.",
  "Global Color Table": "Palette used by images that do not have a Local Color Table.",
  "Image Descriptor": "Defines the position and size of an image frame found within the GIF.",
  "Local Color Table": "Palette specific to the preceding image descriptor.",
  "Image Data": "LZW Compressed image data for the frame.",
  "Graphic Control Extension": "Controls how the following frame is displayed (delay, transparency).",
  "Comment Extension": "Contains human-readable text comments.",
  "Plain Text Extension": "Renders text as a graphic.",
  "Application Extension": "Application-specific data (e.g., Netscape Loop extension).",
  "Trailer": "Marks the end of the GIF file (0x3B).",
  "Extension": "General Extension Block."
};

export const getGifDescription = (name: string): string => {
  return GifDescriptions[name] || "GIF Block";
};
